import styled from "styled-components";

export const LogOutLinkDefaultBox = styled.a`
    display: block;
    padding: 1rem 0rem;
    font-size: 1.4rem;
    line-height: 1;
    transition: color 0.2s ease;
    text-align: center;

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        color: ${props => props.theme.colors.textLight};
    }

    &:hover {
        color: ${props => props.theme.colors.textContrast};
    }
`;
